import { ButtonDefault } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'

import { useFilterForm } from '../FilterForm/FilterFormProvider'

import styles from './FilterSubmitButton.module.scss'

export const FilterSubmitButton = () => {
  const { invalid } = useFilterForm()

  return (
    <div className={styles.container}>
      <ButtonDefault aria-label='Save Filter' disabled={invalid} size='xs' type='submit'>
        <Icon name='check' />
      </ButtonDefault>
    </div>
  )
}
